<template>
	<div>
		<div class="container">
			<el-tabs v-model="activeName" @tab-click="handleClick" :class="'custom-tabs-' + activeName">
				<el-tab-pane label="国美查询" name="single">
					<div class="handle-box">
						<el-input size="small" v-model="serNum" clearable maxlength="12" placeholder="号码"
							style="width: 180px;" class="handle-input mr10"></el-input>
						<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
							@click="getGmPhoneInfo">搜索</el-button>
					</div>
					<div class="table-box" v-if="woData">
						<div class="user-info-box">
							<div class="user-info-tit">账户信息</div>
							<div class="info-box">
								<div class="info-name">入网时间：</div>
								<div class="info" style="">{{woData.joinTime}}</div>
							</div>
							<div class="info-box">
								<div class="info-name">号码状态：</div>
								<div class="info" style="" v-if="woData.serviceStatus==0">换卡</div>
								<div class="info" style="" v-if="woData.serviceStatus==1">开机</div>
								<div class="info" style="" v-if="woData.serviceStatus==2">停机</div>
								<div class="info" style="" v-if="woData.serviceStatus==3">半停</div>
								<div class="info" style="" v-if="woData.serviceStatus==4">销户</div>
							</div>
							<div class="info-box">
								<div class="info-name">状态变化：</div>
								<div class="info" style="" v-if="woData.statusChgType==0">新装</div>
								<div class="info" style="" v-if="woData.statusChgType==1">报开(解挂)</div>
								<div class="info" style="" v-if="woData.statusChgType==2">帐务开机(清欠自动开机)</div>
								<div class="info" style="" v-if="woData.statusChgType==3">强开</div>
								<div class="info" style="" v-if="woData.statusChgType==4">帐务欠停(欠费全停)</div>
								<div class="info" style="" v-if="woData.statusChgType==5">强停</div>
								<div class="info" style="" v-if="woData.statusChgType==6">报停(挂失)</div>
								<div class="info" style="" v-if="woData.statusChgType==7">帐务欠半停(欠费半停)</div>
								<div class="info" style="" v-if="woData.statusChgType==8">预约销户</div>
								<div class="info" style="" v-if="woData.statusChgType==9">预约销户撤销</div>
								<div class="info" style="" v-if="woData.statusChgType==10">销户</div>
								<div class="info" style="" v-if="woData.statusChgType==12">强制销户</div>
								<div class="info" style="" v-if="woData.statusChgType==34">停机保号</div>
								<div class="info" style="" v-if="woData.statusChgType==35">复机</div>
								<div class="info" style="" v-if="woData.statusChgType==50">预开</div>
							</div>
							<div class="info-box">
								<div class="info-name">状态变更时间：</div>
								<div class="info" style="" v-if="woData.statusChgTime">{{woData.statusChgTime}}</div>
							</div>
							<div class="info-box">
								<div class="info-name">卡类型：</div>
								<div class="info">{{woData.simType}}</div>


							</div>
							<div class="info-box">
								<div class="info-name">运营商：</div>
								<div class="info" v-if="woData.basicOrgId==0">联通</div>
								<div class="info" v-if="woData.basicOrgId==1">电信</div>
								<div class="info" v-if="woData.basicOrgId==2">移动</div>
							</div>
							<div class="info-box">
								<div class="info-name">归属地：</div>
								<div class="info">{{woData.provinceCode}}-{{woData.cityCode}}</div>

							</div>

						</div>

						<div class="user-info-box">
							<div class="user-info-tit">资费余量</div>
							<div class="info-box">
								<div class="info-name">当月实时话费：</div>
								<div class="info" style="">{{(woData.currentFee/1000).toFixed(2)||0}}元</div>
							</div>
							<div class="info-box">
								<div class="info-name">余额：</div>
								<div class="info" style="">{{(woData.owningFee/1000).toFixed(2)||0}}元</div>
							</div>
							<div class="info-box" v-for="item in woData.resBookBalanceSummarys" :key="item">
								<div class="info-name">{{item.balanceContent}}套餐：</div>
								<div class="info" style="" :key="item.subjectId">
									<span>本月已使用量{{item.usedAmount.toFixed(2)||0}}{{item.resUnitName}}，当前可用余量:{{item.balanceAmount.toFixed(2)||0}}{{item.resUnitName}}</span>
								</div>
							</div>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="批量查询" name="batch">
					<div class="handle-box">
						<el-button size="small" type="primary" :class="[theme]"
							@click="getbatchQueryRecord">批量查询</el-button>
						<a :href="`${path}dxtQuery.txt`" class="down" style="margin:10px 10px;" download="批量查询模板.txt"
							:class="[theme]">
							<i class="el-icon-download"></i>
							下载模板
						</a>
						<el-button size="small" type="primary" :class="[theme]"
							@click="batchQueryRecords">刷新</el-button>
					</div>
					<el-table :data="tableData" border class="table" ref="multipleTable" max-height="600"
						header-cell-class-name="table-header" :row-style="{ height: '20px' }" v-loading="loading"
						:cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe>
						<el-table-column prop="uid" label="处理批次" align="center" width="350"></el-table-column>
						<el-table-column prop="count" label="总数量" align="center"></el-table-column>
						<el-table-column prop="success" label="成功" align="center"></el-table-column>
						<el-table-column prop="err" label="失败" align="center">
							<template #default="scope">
								<span style="color: #f56c6c;">{{ scope.row.err }}</span>
							</template>
						</el-table-column>
						<el-table-column prop="time" label="时间" align="center"></el-table-column>
						<el-table-column prop="userPhone" label="操作者" align="center"></el-table-column>
						<el-table-column label="操作" width="240" align="center">
							<template #default="scope">
								<a :href="scope.row.url" class="down" download="国美用户信息批量查询数据.text" :class="[theme]">
									<i class="el-icon-download"></i>
									下载
								</a>
							</template>
						</el-table-column>
					</el-table>
					<div class="pagination">
						<el-pagination background layout="total, sizes, prev, pager, next, jumper"
							:current-page="batchquery.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
							:page-size="batchquery.pageSize" :total="pageTotal" @size-change="handleSizeChange"
							@current-change="handlePageChange"></el-pagination>
					</div>
				</el-tab-pane>
			</el-tabs>
			<el-dialog title="批量查询" v-model="addVisible" width="520px" @close="closeDialog">
				<el-form label-width="120px" :model="addForm" ref="editForm">
					<el-form-item label="上传类型" prop="type">
						<el-radio-group v-model="addForm.type">
							<el-radio label="2">手动输入</el-radio>
							<el-radio label="1">批量查询模板</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="上传文件" v-if="addForm.type=='1'">
						<el-upload ref="upload" action="/api/gome/batchQuery" :headers="token" :limit="1"
							:on-success="uploadSuccess" :auto-upload="false" :data="uploadData">
							<el-button size="small" type="primary" :class="[theme]"
								style="margin-top: 40px;">选择文件</el-button>
							<div class="el-upload__tip">只能导入txt文件</div>
						</el-upload>
					</el-form-item>
					<el-form-item label="批量查询" v-if="addForm.type=='2'">
						<el-input size="small" :rows="5" type="textarea" v-model="addForm.phones" auto-complete="off"
							placeholder="一行一个手机号码,一次最多添加500个号码"></el-input>
					</el-form-item>
					<el-form-item class="dis-end">
						<el-button size="small" @click="closeDialog">取消</el-button>
						<el-button size="small" type="primary" :class="[theme]" v-if="addForm.type == '2'"
							@click="getbatchQuery">确定</el-button>
						<el-button size="small" type="primary" :class="[theme]" v-else
							@click="submitUpload">确定</el-button>
					</el-form-item>
				</el-form>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import {
		GmPhoneInfo,
		batchQueryRecord,
		batchQuery,
	} from '../../api/gm.js';
	export default {
		name: 'gmQuery',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				serNum: '',
				batchquery: {
					pageIndex: 1,
					pageSize: 10,
					userId: localStorage.getItem('user'),
				},
				woData: '',
				activeName: 'single',
				uploadData: {
					userId: localStorage.getItem('user'),
					type: '1'
				},
				addVisible: false,
				tableData: [],
				pageTotal: 0,
				token: {
					Authorization: localStorage.getItem('token'),
					type: 'web',
					UserRole: localStorage.getItem('ms_role'),
					XSecurityVersion: 'v2'
				},
				path: process.env.BASE_URL,
				addForm: {
					userId: localStorage.getItem('user'),
					phones: '',
					type: "2",
				}
			};
		},

		created() {
			console.log('=== gmQuery.vue 组件初始化 ===');
			console.log('浏览器信息:', navigator.userAgent);
			console.log('当前主题:', this.theme);
			console.log('当前theme8:', this.theme8);
			console.log('查询号码:', this.serNum);
			if (this.serNum) {
				this.getGmPhoneInfo();
				this.updateTabStyle();
				this.updatePaginationStyle();
			}
		},

		methods: {
			updatePaginationStyle() {
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .el-pager .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.el-pager .number:hover {
				        color: ${this.theme8} !important;
				    }
					.el-pager .active:hover {
					    color: #fff !important;
					}
					.el-pager .more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			updateTabStyle() {
				// 动态更新样式
				let styleEl = document.getElementById('dynamic-tab-style');
				if (!styleEl) {
					styleEl = document.createElement('style');
					styleEl.id = 'dynamic-tab-style';
					document.head.appendChild(styleEl);
				}

				styleEl.innerHTML = `
			        .el-tabs__active-bar {
			            background-color: ${this.theme8} !important;
			        }
			        .el-tabs__item.is-active {
			            color: ${this.theme8} !important;
			        }
			        .el-tabs__item:hover {
			            color: ${this.theme8} !important;
			            opacity: 0.8;
			        }
			    `;
			},
			handleClick(tab, event) {
				this.activeName = tab.props.name;
				if (tab.props.name == 'single') {
					// this.getGmPhoneInfo();
				} else {
					this.batchQueryRecords();
				}
			},
			getGmPhoneInfo() {
				console.log('=== getGmPhoneInfo 方法调用 ===');
				console.log('查询号码:', this.serNum.trim());
				this.woData = '';
				GmPhoneInfo(this.serNum.trim()).then(res => {
					console.log('API响应:', res);
					if (res?.code === 200) {
						this.woData = res.data;
						console.log('数据加载成功:', this.woData);
						console.log('woData类型:', typeof this.woData);
					} else {
						console.log('API调用失败:', res.message);
						this.$message.error(res.message);
					}
				}).catch(err => {
					console.error('API调用异常:', err);
				});
			},
			batchQueryRecords() {
				this.loading = true;
				batchQueryRecord(this.batchquery).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data.list;
						this.pageTotal = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getbatchQuery() {
				batchQuery(this.addForm).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.data);
						this.addVisible = false;
						this.batchQueryRecords();
					} else {
						this.$message.error(res.message);
					}
				});
			},
			submitUpload() {
				if (this.$refs.upload.uploadFiles[0]) {
					this.loading = true;
					this.$refs.upload.submit();
					this.batchQueryRecords();
				} else {
					this.$message.error('请选择上传文件');
				}
			},
			//导入上传
			uploadSuccess(success) {
				setTimeout(() => {
					this.$refs.upload.clearFiles();
					this.addVisible = false;
				}, 2000);
				if (success?.code === 200) {
					this.$message.success('上传成功');
					this.batchQueryRecords();
				} else {
					// this.open(success.message);
					this.$message.error(success.message);
				}
			},
			getbatchQueryRecord() {
				this.addVisible = true;
				this.addForm.type = '2';
				this.addForm.phones = '';
			},
			closeDialog() {
				this.addVisible = false;
			},
			handlePageChange(val) {
				this.batchquery.pageIndex = val;
				this.batchQueryRecords();
			},
			handleSizeChange(val) {
				this.batchquery.pageSize = val;
				this.query.pageIndex = 1; // 重置到第一页
				this.batchQueryRecords();
			},
			toDateTimeStr(dateTime) {
				const date = new Date(dateTime);

				// 使用Date对象的方法来获取年月日时分秒
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份是从0开始的，所以需要+1，并用'0'填充
				const day = String(date.getDate()).padStart(2, '0');
				const hours = String(date.getHours()).padStart(2, '0');
				const minutes = String(date.getMinutes()).padStart(2, '0');
				const seconds = String(date.getSeconds()).padStart(2, '0');
				// 拼接成完整的日期时间字符串
				const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
				// 返回格式化后的日期时间字符串
				return formattedDateTime;
			}
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	/* a:hover {
	background: #66b1ff;
} */
	.handle-select {
		width: 240px;
	}

	.table {
		width: 100%;
		font-size: 12px;
	}

	.red {
		color: #f56c6c;
	}

	.mr10 {
		margin-right: 10px;
	}

	.mr100 {
		position: absolute;
		right: 100px;
	}

	.myRight {
		position: absolute;
		right: 10px;
		bottom: 10px;
	}

	.handle-input {
		width: 200px;
		display: inline-block;
	}

	.recharge-box .el-radio__input {
		display: none;
	}

	.recharge-box .el-radio.is-bordered {
		padding: 8px 14px 0 5px;
		border-radius: 4px;
		border: 1px solid #dcdfe6;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		height: 30px;
	}

	.table-box {
		/* width: 1700px; */
		/* border: 1px solid #ebeef5; */
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-orient: horizontal;
		-webkit-box-direction: normal;
		-webkit-flex-direction: row;
		-ms-flex-direction: row;
		flex-direction: row;
		margin-bottom: 40px;
	}

	.user-info-box {
		/* border: 1px solid #ebeef5; */

		width: 50%;
	}

	.user-info-tit {
		background: #fafafa;
		color: #000;
		font-weight: 600;
		text-align: center;
		line-height: 34px;
		border-right: 1px solid #ebeef5;
		border-bottom: 1px solid #ebeef5;
	}

	.info-box {
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-orient: horizontal;
		-webkit-box-direction: normal;
		-webkit-flex-direction: row;
		-ms-flex-direction: row;
		flex-direction: row;
		line-height: 34px;
		border-bottom: 1px solid #ebeef5;
		border-right: 1px solid #ebeef5;
	}

	.info-name {
		background: #fafafa;
		border-right: 1px solid #ebeef5;
		border-left: 1px solid #ebeef5;
		width: 30%;
		padding-left: 10px;
		font-weight: 600;
	}

	.user-info-box .info-box .info {
		padding-left: 10px;
		color: #226003;
		width: 80%;
		max-width: 80%;
		overflow-wrap: break-word;
		/* 允许单词内换行 */
		word-break: break-word;
		/* 更兼容的断词方式 */
		white-space: normal;
		/* 确保默认换行行为 */

	}

	.down {
		border: 1px solid #dcdfe6;
		background: #4f7afd;
		color: #ffffff;
		transition: 0.1s;
		font-weight: 500;
		padding: 6px 12px;
		font-size: 12px;
		border-radius: 4px;
		display: inline-block;
	}
</style>